'use client'

import { PropsWithChildren } from 'react';

interface CardBoxDefaultProps {
  title?: any;
  icon?: any;
  className?: string;
}

const CardBoxDefault = ({title, icon, className, children}: PropsWithChildren<CardBoxDefaultProps>) => {
  return (
    <div className={`grid gap-2 p-4 ring-1 ring-gray-100 shadow rounded-lg bg-white ${className}`}>
      {(title || icon) && (
        <div className="flex items-center gap-2">
            {icon}
            {title && <h3 className="text-lg font-bold text-shopfood-title">{title}</h3>}
        </div>
      )}

      {children}
    </div>
  )
}

export default CardBoxDefault;